import React from "react";

import { Alert } from "react-bootstrap";

const GlobalError = props => {
  return (
    <div>
      <Alert bsStyle="danger">
        {props.messages.map((message, index) => {
          return <div key={`gem-${index}`}>{message}</div>;
        })}
      </Alert>
    </div>
  );
};

export default GlobalError;
